import EquipLogoHorizontal from "@/assets/images/equip-logo-horizontal.png";
import Image from "@/ui/core/Image";

type EquipLogoInlineSize = "md" | "sm";

const SizeConfig: Record<
  EquipLogoInlineSize,
  { height: number; width: number }
> = {
  md: { height: 24, width: 102 },
  sm: { height: 16, width: 68 },
};

interface EquipLogoInlineProps {
  size?: EquipLogoInlineSize;
}

const EquipLogoInline = ({ size = "md" }: EquipLogoInlineProps) => {
  const dimensions = SizeConfig[size];

  return (
    <Image
      contentFit="contain"
      size={dimensions}
      testID="equip-logo"
      uriSource={EquipLogoHorizontal}
    />
  );
};

export default EquipLogoInline;
